import React from "react";
import { Input, Label } from "reactstrap";
import CurrencyFormat from "react-currency-format";

const vehicleTypeName = (vehicleType) => {
  const options = {
    'auto': 'Automóvil',
    'moto': 'Motocicleta',
    'camion': 'Camión',
    'bus': 'Bus - Minibus',
  };
  return options[vehicleType] || vehicleType;
};

const AdjudgeContent = ({ offert }) => (
  <div className="crm-adjudge-form-container">
    <div className="crm-modal-adjudge-form-group">
      <div className="crm-modal-input-group">
        <Label>Tipo Vehículo</Label>
        <Input
          className='crm-modal-input-text'
          type='text'
          value={vehicleTypeName(offert.vehicleType)}
        />
      </div>
      <div className="crm-modal-input-group">
        <Label htmlFor='brand'>Marca</Label>
        <Input
          className='crm-modal-input-text'
          id='brand'
          type='text'
          value={offert.brand}
        />
      </div>
      <div className="crm-modal-input-group">
        <Label>Modelo</Label>
        <Input
          className='crm-modal-input-text'
          type='text'
          value={offert.model}
        />
      </div>
      <div className="crm-modal-input-group">
        <Label>Año</Label>
        <Input
          className='crm-modal-input-text'
          type='text'
          value={offert.year}
        />
      </div>
    </div>
    <div className="crm-modal-adjudge-form-group">
      <div className="crm-modal-input-group">
        <Label>Versión</Label>
        <Input
          className='crm-modal-input-text'
          type='text'
          value={offert.version}
        />
      </div>
      <div className="crm-modal-input-group">
        <Label>Precio Vehículo</Label>      
        <CurrencyFormat  
          className='crm-modal-input-text'
          value={offert.vehiclePrice}
          decimalSeparator=","
          thousandSeparator="."
          prefix={"$"}
          customInput={Input}
        />      
      </div>
      <div className="crm-modal-input-group">
        <Label>Kilometraje</Label>
        <Input
          className='crm-modal-input-text'
          type='text'
          value={offert.kilometers}
        />
      </div>
      <div className="crm-modal-input-group">
        <Label>Canal Auto</Label>
        <Input
          className='crm-modal-input-text'
          type='text'
          value={offert.carChannel}
        />
      </div>
    </div>
    <div className="crm-modal-form-group-textarea">
      <div className="crm-modal-input-group">
        <Label>Descripción</Label>
        <Input
          className='crm-modal-input-textarea'
          type='textarea'
          value={offert.comment}
          maxLength='300'
        />
      </div>
    </div>
  </div>
);

export default AdjudgeContent;